import { Navigate, useRoutes } from "react-router-dom";
import {
  CHECKIN,
  DASHBOARD,
  DIETARY_EDIT,
  DIETARY_MANAGEMENT,
  EVENT_INFO,
  EVENT_LIST,
  EVENT_CHECK_IN_PAGE,
  GUEST_ADD,
  GUEST_BULK_EDIT,
  GUEST_BULK_PREVIEW,
  GUEST_EDIT,
  GUEST_LIST,
  GUEST_LIST_IMPORT_LOG,
  GUEST_LIST_IMPORT_LOG_DETAILS,
  LOGIN,
  MESSAGE_BLAST,
  MESSAGE_BLAST_ADD,
  MESSAGE_BLAST_EDIT,
  REPORT_OVERVIEW,
  SEATING_CHART,
  SEATS_MANAGEMENT,
  SEATS_MANAGEMENT_EDIT,
  GUEST_INVITATION,
  MESSAGE_BLAST_PREVIEW,
  EVENT_PREVIEW,
  GUEST_COUNTER,
  TAG_MANAGEMENT,
  TAG_MANAGEMENT_EDIT,
  CHANGE_LOG,
  USER_LIST,
  USER_CREATE,
  USER_EDIT,
  LOW_END_EVENT_LIST,
  LOW_END_EVENT_INFO,
  LOW_END_GUEST_LIST,
  LOW_END_CHECKIN,
} from "./path";
import EventList from "../Pages/EventList";
import Login from "../Pages/Login";
import EventPage from "../Pages/Event/EventPage";
import Dashboard from "../Pages/Dashboard";
import GuestListPage from "../Pages/Guests/GuestListPage";
import GuestBulkEditPage from "../Pages/Guests/GuestBulkEditPage";
import GuestAdd from "../Pages/Guests/GuestAdd";
import GuestEdit from "../Pages/Guests/GuestEdit";
import CheckInList from "../Pages/CheckIn/CheckInList";
import ReportOverview from "../Pages/ReportOverview";
import MainLayout from "../Components/MainLayout";
import MessageBlast from "../Pages/MessageBlast/MessageBlast";
import MessageBlastAdd from "../Pages/MessageBlast/MessageBlastAdd";
import MessageBlastEdit from "../Pages/MessageBlast/MessageBlastEdit";
import SeatManagementList from "../Pages/SeatManagement/SeatManagementList";
import SeatManagementEdit from "../Pages/SeatManagement/SeatManagementEdit";
import DietaryList from "../Pages/DietaryManagement/DietaryList";
import DietaryEdit from "../Pages/DietaryManagement/DietaryEdit";
import SeatingChart from "../Pages/SeatingChart/SeatingChart";
import EventCheckInPage from "../Pages/CheckIn/EventCheckInPage";
import GuestBulkUploadPreview from "../Pages/Guests/GuestBulkUploadPreview";
import ImportLogList from "../Pages/ImportLog/ImportLogList";
import ImportLogDetails from "../Pages/ImportLog/ImportLogDetails";
import Invitation from "../Pages/GuestInterface/Invitation";
import MessageBlastPreview from "../Pages/MessageBlast/MessageBlastPreview";
import EventPreview from "../Pages/Event/EventPreview";
import GuestCounter from "../Pages/GuestCounter";
import TagsList from "../Pages/Tags/TagsList";
import TagsEdit from "../Pages/Tags/TagsEdit";
import ChangeLog from "../Pages/ChangeLog/ChangeLog";
import UserCreate from "../Pages/UserManagement/UserCreate";
import UserEdit from "../Pages/UserManagement/UserEdit";

import { ProtectedRoute } from "../Components/ProtectedRoute";
import UserList from "../Pages/UserManagement/UserList";
import LEEventList from "../Pages/LowEndMode/LEEventList";
import LEEventInfo from "../Pages/LowEndMode/LEEventInfo";
import LEGuestList from "../Pages/LowEndMode/LEGuestList";
import LESelfCheckIn from "../Pages/LowEndMode/LESelfCheckIn";

export default function Router() {
  const isAuthenticated = () => !!sessionStorage.getItem("bearer_token");
  const hasEventSelected = () => !!sessionStorage.getItem("event_id");

  const routes = [
    {
      path: "*",
      element: isAuthenticated() ? (
        <Navigate to={EVENT_LIST} />
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: GUEST_INVITATION,
      element: <Invitation />,
    },
    {
      path: LOGIN,
      element: isAuthenticated() ? <Navigate to={EVENT_LIST} /> : <Login />,
    },
    {
      path: EVENT_LIST,
      element: isAuthenticated() ? <EventList /> : <Navigate to={LOGIN} />,
    },
    {
      path: DASHBOARD,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_dashboard">
            <MainLayout>
              <Dashboard />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={EVENT_LIST} />
        )
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: EVENT_INFO,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_event_page">
            <MainLayout>
              <EventPage />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={EVENT_LIST} />
        )
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: GUEST_LIST,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_guest_list">
            <MainLayout>
              <GuestListPage />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: GUEST_BULK_PREVIEW,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_guest_list">
            <MainLayout>
              <GuestBulkUploadPreview />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: GUEST_BULK_EDIT,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="edit_guest">
            <MainLayout>
              <GuestBulkEditPage />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: GUEST_ADD,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="create_guest">
            <MainLayout>
              <GuestAdd />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: GUEST_EDIT,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="edit_guest">
            <MainLayout>
              <GuestEdit />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: MESSAGE_BLAST,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_message_blast">
            <MainLayout>
              <MessageBlast />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: MESSAGE_BLAST_ADD,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="create_message_blast">
            <MainLayout>
              <MessageBlastAdd />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: MESSAGE_BLAST_PREVIEW,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_message_blast">
            <MessageBlastPreview />
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: MESSAGE_BLAST_EDIT,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="edit_message_blast">
            <MainLayout>
              <MessageBlastEdit />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: CHECKIN,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_check_in">
            <MainLayout>
              <CheckInList />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: SEATING_CHART,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_seating_chart">
            <SeatingChart />
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: REPORT_OVERVIEW,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_report">
            <MainLayout>
              <ReportOverview />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: TAG_MANAGEMENT,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_tag_management">
            <MainLayout>
              <TagsList />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={EVENT_LIST} />
        )
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: TAG_MANAGEMENT_EDIT,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="edit_tag">
            <MainLayout>
              <TagsEdit />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={EVENT_LIST} />
        )
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: SEATS_MANAGEMENT,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          sessionStorage.getItem("seat") === "true" ? (
            <ProtectedRoute permission="view_seat_management">
              <MainLayout>
                <SeatManagementList />
              </MainLayout>
            </ProtectedRoute>
          ) : (
            <Navigate to={DASHBOARD} />
          )
        ) : (
          <Navigate to={EVENT_LIST} />
        )
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: SEATS_MANAGEMENT_EDIT,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          sessionStorage.getItem("seat") === "true" ? (
            <ProtectedRoute permission="edit_seat">
              <MainLayout>
                <SeatManagementEdit />
              </MainLayout>
            </ProtectedRoute>
          ) : (
            <Navigate to={DASHBOARD} />
          )
        ) : (
          <Navigate to={EVENT_LIST} />
        )
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: DIETARY_MANAGEMENT,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          sessionStorage.getItem("dietary") === "true" ? (
            <ProtectedRoute permission="view_special_dietary">
              <MainLayout>
                <DietaryList />
              </MainLayout>
            </ProtectedRoute>
          ) : (
            <Navigate to={DASHBOARD} />
          )
        ) : (
          <Navigate to={EVENT_LIST} />
        )
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: DIETARY_EDIT,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          sessionStorage.getItem("dietary") === "true" ? (
            <ProtectedRoute permission="edit_special_dietary">
              <MainLayout>
                <DietaryEdit />
              </MainLayout>
            </ProtectedRoute>
          ) : (
            <Navigate to={DASHBOARD} />
          )
        ) : (
          <Navigate to={EVENT_LIST} />
        )
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: GUEST_LIST_IMPORT_LOG,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_guest_import_log">
            <MainLayout>
              <ImportLogList />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: GUEST_LIST_IMPORT_LOG_DETAILS,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_guest_import_log">
            <MainLayout>
              <ImportLogDetails />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: CHANGE_LOG,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_change_log">
            <MainLayout>
              <ChangeLog />
            </MainLayout>
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: EVENT_CHECK_IN_PAGE,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_event_check_in_page">
            <EventCheckInPage />
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: EVENT_PREVIEW,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="edit_event_page">
            <EventPreview />
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={EVENT_LIST} />
      ),
    },
    {
      path: GUEST_COUNTER,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="view_live_dashboard">
            <GuestCounter />
          </ProtectedRoute>
        ) : (
          <Navigate to={DASHBOARD} />
        )
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: USER_LIST,
      element: isAuthenticated() ? (
        <ProtectedRoute permission="view_user">
          <UserList />
        </ProtectedRoute>
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: USER_CREATE,
      element: isAuthenticated() ? (
        <ProtectedRoute permission="create_user">
          <UserCreate />
        </ProtectedRoute>
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: USER_EDIT,
      element: isAuthenticated() ? (
        <ProtectedRoute permission="edit_user">
          <UserEdit />
        </ProtectedRoute>
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: LOW_END_EVENT_LIST,
      element: isAuthenticated() ? (
        <ProtectedRoute permission="low_end_event_view">
          <LEEventList />
        </ProtectedRoute>
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: LOW_END_EVENT_INFO,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="low_end_event_view">
            <LEEventInfo />
          </ProtectedRoute>
        ) : (
          <Navigate to={LOW_END_EVENT_LIST} />
        )
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: LOW_END_GUEST_LIST,
      element: isAuthenticated() ? (
        hasEventSelected() ? (
          <ProtectedRoute permission="low_end_event_view">
            <LEGuestList />
          </ProtectedRoute>
        ) : (
          <Navigate to={LOW_END_EVENT_LIST} />
        )
      ) : (
        <Navigate to={LOGIN} />
      ),
    },
    {
      path: LOW_END_CHECKIN,
      element: <LESelfCheckIn />,
    },
  ];

  return useRoutes(routes);
}
